// import { useState, useEffect } from "react";

// function LoadingOverlay({ type }) {
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     if (type === 1) {
//       const interval = setInterval(() => {
//         setProgress((prev) =>
//           prev < 95 ? prev + Math.floor(Math.random() * 5) + 1 : prev
//         );
//       }, 300);

//       return () => clearInterval(interval);
//     }
//   }, []);

//   const overlayClasses =
//     "fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center";

//   if (type === 1) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black flex items-center justify-center">
//         <div className="text-white text-center space-y-4">
//           {/* Spinner */}
//           <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto"></div>

//           {/* Text */}
//           <p className="text-xl font-semibold tracking-wide">
//             Loading... {progress}%
//           </p>

//           {/* Progress Bar */}
//           <div className="w-64 h-3 bg-gray-700 rounded-full overflow-hidden mx-auto">
//             <div
//               className="h-full bg-blue-500 transition-all duration-300 ease-in-out"
//               style={{ width: `${progress}%` }}
//             ></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (type === 2) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
//         <div className="text-white text-center space-y-4">
//           <div className="w-20 h-20 mx-auto relative animate-spin-slow">
//             <div className="text-5xl animate-bounce">🏏</div>
//             <div className="absolute inset-0 flex items-center justify-center animate-rotate-y">
//               <span className="text-5xl">🏏</span>
//             </div>
//           </div>
//           <p className="text-xl font-semibold tracking-wide animate-pulse">
//             Setting up the pitch...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (type === 3) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
//         <div className="text-center">
//           <svg
//             className="animate-spin mx-auto h-12 w-12 text-white"
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//           >
//             <circle
//               className="opacity-25"
//               cx="12"
//               cy="12"
//               r="10"
//               stroke="currentColor"
//               strokeWidth="4"
//             ></circle>
//             <path
//               className="opacity-75"
//               fill="currentColor"
//               d="M4 12a8 8 0 018-8v8H4z"
//             ></path>
//           </svg>
//           <p className="mt-4 text-white text-lg">Initializing...</p>
//         </div>
//       </div>
//     );
//   }

//   if (type === 4) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
//         <div className="text-white text-center space-y-4">
//           <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto"></div>
//           <p className="text-xl font-semibold tracking-wide">Loading...</p>
//           <div className="w-64 h-3 bg-gray-700 rounded-full overflow-hidden mx-auto">
//             <div className="h-full bg-gradient-to-r from-blue-400 via-blue-500 to-blue-400 animate-[shimmer_2s_infinite] w-full"></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (type === 5) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
//         <div className="text-white text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mx-auto mb-4"></div>
//           <p className="text-lg">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   if (type === 6) {
//     return (
//       <div className={overlayClasses}>
//         <div className="flex flex-col items-center">
//           <div className="relative w-16 h-16">
//             <div className="absolute border-4 border-transparent border-t-purple-500 rounded-full w-full h-full animate-spin"></div>
//             <div className="absolute border-4 border-transparent border-b-purple-500 rounded-full w-full h-full animate-spin-slow"></div>
//           </div>
//           <p className="mt-4 text-white text-lg font-semibold">
//             Getting things ready...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (type === 7) {
//     return (
//       <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
//         <div className="flex space-x-2">
//           {[0, 1, 2, 3, 4].map((i) => (
//             <div
//               key={i}
//               className="w-2 h-6 bg-primary rounded-sm"
//               style={{
//                 animation: "pulseBar 1.2s ease-in-out infinite",
//                 animationDelay: `${i * 0.15}s`,
//               }}
//             />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (type === 8) {
//     return <></>;
//   }

//   if (type === 9) {
//     return <></>;
//   }

//   if (type === 10) {
//     return <></>;
//   }

//   return null; // if no type matches
// }

// export default LoadingOverlay;

import { useState, useEffect } from "react";

function LoadingOverlay({ type }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (type === 1) {
      const interval = setInterval(() => {
        setProgress((prev) =>
          prev < 95 ? prev + Math.floor(Math.random() * 5) + 1 : prev,
        );
      }, 300);

      return () => clearInterval(interval);
    }
  }, [type]);

  const overlayClasses =
    "fixed inset-0 z-50 bg-black/20 backdrop-blur-sm flex items-center justify-center";

  if (type === 1) {
    return (
      <div className={overlayClasses}>
        <div className="text-white text-center space-y-4">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto"></div>

          <p className="text-xl font-semibold tracking-wide">
            Loading... {progress}%
          </p>

          <div className="w-64 h-3 bg-white/10 rounded-full overflow-hidden mx-auto">
            <div
              className="h-full bg-blue-500 transition-all duration-300 ease-in-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 2) {
    return (
      <div className={overlayClasses}>
        <div className="text-white text-center space-y-4">
          <div className="w-20 h-20 mx-auto relative animate-spin-slow">
            <div className="text-5xl animate-bounce">🏏</div>
            <div className="absolute inset-0 flex items-center justify-center animate-rotate-y">
              <span className="text-5xl">🏏</span>
            </div>
          </div>

          <p className="text-xl font-semibold tracking-wide animate-pulse">
            Setting up the pitch...
          </p>
        </div>
      </div>
    );
  }

  if (type === 3) {
    return (
      <div className={overlayClasses}>
        <div className="text-center">
          <svg
            className="animate-spin mx-auto h-12 w-12 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>

            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>

          <p className="mt-4 text-white text-lg">Initializing...</p>
        </div>
      </div>
    );
  }

  if (type === 4) {
    return (
      <div className={overlayClasses}>
        <div className="text-white text-center space-y-4">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto"></div>

          <p className="text-xl font-semibold tracking-wide">Loading...</p>

          <div className="w-64 h-3 bg-white/10 rounded-full overflow-hidden mx-auto">
            <div className="h-full bg-gradient-to-r from-blue-400 via-blue-500 to-blue-400 animate-[shimmer_2s_infinite] w-full"></div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 5) {
    return (
      <div className={overlayClasses}>
        <div className="text-white text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mx-auto mb-4"></div>

          <p className="text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  if (type === 6) {
    return (
      <div className={overlayClasses}>
        <div className="flex flex-col items-center">
          <div className="relative w-16 h-16">
            <div className="absolute border-4 border-transparent border-t-purple-500 rounded-full w-full h-full animate-spin"></div>

            <div className="absolute border-4 border-transparent border-b-purple-500 rounded-full w-full h-full animate-spin-slow"></div>
          </div>

          <p className="mt-4 text-white text-lg font-semibold">
            Getting things ready...
          </p>
        </div>
      </div>
    );
  }

  if (type === 7) {
    return (
      <div className={overlayClasses}>
        <div className="flex space-x-2">
          {[0, 1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="w-2 h-6 bg-primary rounded-sm"
              style={{
                animation: "pulseBar 1.2s ease-in-out infinite",
                animationDelay: `${i * 0.15}s`,
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  if (type === 8 || type === 9 || type === 10) {
    return <></>;
  }

  return null;
}

export default LoadingOverlay;
